<div class="card credenciais-api-container">
    <p-toolbar styleClass="mb-4 credenciais-api-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple [disabled]="permissaoService.can('cadastro_de_usuarios_inserir') == false"
                label="Novo API" icon="pi pi-plus" class="p-button-success mr-2" (click)="openNewApi()"></button>
        </ng-template>

    </p-toolbar>

    <div class="credenciais-api-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','name','email', 'empresa']"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Credencias de API</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 8%">Código</th>
                <th style="width: 18%">Nome</th>
                <th style="width: 20%">E-mail</th>
                <th style="width: 10%">Tipo</th>
                <th style="width: 16%">Data do cadastro</th>
                <th class="col-acoes" style="width: 14%; min-width: 120px">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Nome: </span>{{dt.name}}</td>
                <td><span class="p-column-title negrito">E-mail: </span>{{dt.email}}</td>
                <td><span class="p-column-title negrito">Tipo: </span>{{dt.tipo == 1 ? 'Api' : 'Usuário'}}</td>
                <td><span class="p-column-title negrito">Data do cadastro: </span>{{dt.created_at | date:
                    'dd/MM/yyyy' }}</td>
                <td class="col-acoes" style="text-align: center; white-space: nowrap">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton [disabled]="permissaoService.can('cadastro_de_usuarios_inserir') == false" pRipple
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        pTooltip="Editar" (click)="editApi(dt)"></button>
                    <button pButton [disabled]="permissaoService.can('credenciais_api_excluir') == false" pRipple
                        icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        pTooltip="Excluir usuário API" (click)="confirmarExclusao(dt)"></button>
                </td>
            </tr>
        </ng-template>

        </p-table>
    </div>
</div>

<p-dialog header="Usuário API" [(visible)]="displayModalApi" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="formApi" class="p-fluid grid">
            <div class="field field-label-top col-12 md:col-12 xl:col-12">
                <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                <label class="form-check-label" for="ativo">Ativo</label>
            </div>

            <div class="field field-label-top col-12 md:col-12 xl:col-6">
                <label for="empresa_id">Empresa</label>
                <p-select
                    inputId="empresa_id"
                    formControlName="empresa_id"
                    [options]="dropDownEmpresas"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterBy="label"
                    filterPlaceholder="Buscar..."
                    placeholder="Selecione a empresa"
                    [autoDisplayFirst]="false"
                    appendTo="body"
                    styleClass="w-full">
                    <ng-template #selectedItem let-selectedOption>
                        <span *ngIf="selectedOption">{{ selectedOption.label }}</span>
                    </ng-template>
                    <ng-template let-empresa #item>
                        <span>{{ empresa.label }}</span>
                    </ng-template>
                </p-select>
                <small id="empresa-help" *ngIf="formApi.get('empresa_id').value == null" class="p-error">
                    Empresa é obrigatório.
                </small>
            </div>

            <div class="field field-label-top col-12 md:col-12 xl:col-6">
                <label for="api_key">API Key</label>
                <div class="flex align-items-center gap-2">
                    <input type="text" id="api_key" pInputText formControlName="api_key" [readonly]="true" class="w-full flex-1">
                    <button pButton type="button" icon="pi pi-download" class="p-button-rounded p-button-text flex-shrink-0"
                            (click)="downloadFile('api_key.txt', formApi.get('api_key').value)"
                            *ngIf="formApi.get('api_key').value"></button>
                </div>
            </div>

            <div class="field field-label-top col-12">
                <label for="secret">Secret</label>
                <div class="flex align-items-center gap-2">
                    <input type="text" id="secret" pInputText formControlName="secret"
                        [value]="isEditing ? '************************************' : formApi.get('secret').value"
                        [readonly]="true" class="w-full flex-1">
                    <button pButton type="button" icon="pi pi-download" class="p-button-rounded p-button-text flex-shrink-0"
                            (click)="downloadFile('secret.txt', formApi.get('secret').value)"
                            *ngIf="formApi.get('secret').value && (!isEditing || (isEditing && !secretDownloaded))"></button>
                    <button pButton type="button" icon="pi pi-refresh" class="p-button-rounded p-button-text flex-shrink-0"
                            (click)="generateNewSecret()"
                            *ngIf="isEditing"></button>
                </div>
            </div>

        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModalApi = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false"
            pButton pRipple type="button" icon="pi pi-check" (click)="saveApi()" label="Salvar"
            class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>